







































































































import { Component, Prop, Vue } from "vue-property-decorator";
import PlaceWorkingHours from "@/components/PlaceWorkingHours.vue";
import PlaceSocialNetworks from "@/components/PlaceSocialNetworks.vue";
@Component({
  components: {PlaceSocialNetworks, PlaceWorkingHours}
})
export default class PlaceItemDetails extends Vue {
  @Prop() place!: any;
  @Prop() placeIsLoading!: boolean;

  get company() {
    return this.place.company ? this.place.company : null;
  }

  get logoLetter() {
    return this.place.name[0];
  }

  get processedPhones() {
    let phones = this.place.phone;

    phones = phones.replace(/:/g, "<br />");

    const icon = `<i class="fa fa-phone" aria-hidden="true"></i>`

    return phones.replace(/((\d[\d\-.]*){9,})/g,
      `<a class="phone-number" href="tel://$1">${icon}$1</a>`);
  }

  get whatsappPhone() {
    if (this.place.whatsappPhone) {
      const phone = this.place.whatsappPhone
        .replace(/^0/,"58")
        .replace("+", "");
      const displayPhone = phone.replace("58", "0")
      return `<a class="whatsapp-phone-number" href="https://wa.me/${phone}">` +
        `<i class="fa fa-whatsapp" aria-hidden="true"></i>${displayPhone}</a>`;
    } else {
      return null;
    }
  }

  get maskedEmail() {
    if (this.place.email) {
      return this.place.email.replace(/...@.../, '***@***').replace(/......@.../, '******@***');
    } else {
      return null;
    }
  }

  get maskedEmailHtml() {
    if (this.place.email) {
      return this.place.email.replace("@", '<i class="fa fa-at" aria-hidden="true"></i>');
    } else {
      return null;
    }
  }

  get cleanWebsite() {
    const url = this.place.company.websiteUrl;
    if (url) {
      if (url.match(/^http[s]?:.+/) !== null) {
        return url;
      } else {
        return `http://${url}`
      }
    } else {
      return null;
    }
  }

  get placeAddress() {
    let address = "";
    if (this.place) {
      if (!this.place.noStreetAddress) {
        address = `${this.place.address}, `
      }
      address += `${this.place.city.name}`
    }

    return address;
  }

  get placeHasCoordinates() {
    return (this.place.coordiantes &&
      this.place.coordinates.lat &&
      this.place.coordinates.lon)
  }

  get placeDescription() {
    return this.place.company.description;
  }

  get parsedFeatures() {
    const featuresArr = this.place.features.features;

    const parsedFeaturesArr = this.$store.state.staticPlaceFeatures.filter( (f: any) => {
      return featuresArr.some( (id:number) => f.id == id)
    });

    return parsedFeaturesArr;
  }

  get hasSocialNetworks() {
    const socialJson = JSON.parse(this.company.socialNetworks)
    return (socialJson && ((socialJson.fbUrl && socialJson.fbUrl.length > 3) ||
      (socialJson.twUser && socialJson.twUser.length > 3) ||
      (socialJson.igUser && socialJson.igUser.length > 3)));
  }

  emailOnClick(event: any) {
    if (event) {
      event.preventDefault()
    }
    window.open(`mailto:${this.place.email}`, '_blank', "noopener noreferrer");
  }
}
